export const userEndpoints = {
  createUser: { method: 'post', path: '/' },
  listUserDetails: { method: 'get', path: '/list' },
  listGroups: { method: 'get', path: '/groups/list' },
  createGroup: { method: 'post', path: '/groups' },
  updateGroup: { method: 'post', path: '/groups/{groupId}' },
  getGroupMembers: { method: 'get', path: '/groups/{groupId}/members' },
  updateUser: { method: 'post', path: '/{userId}/update' },
  getUserByEmail: { method: 'get', path: '/by-email/{email}' },
  getUsersByIds: { method: 'post', path: '/by-ids' },
  computeInfoAndPreferences: { method: 'post', path: '/compute-info-and-preferences' },
  getUserPreferences: { method: 'get', path: '/{userId}/preferences' },
  updateUserPreferences: { method: 'post', path: '/{userId}/preferences' },
  updateRequestPreferences: { method: 'post', path: '/{userId}/request-preferences' },
  unarchiveUser: { method: 'post', path: '/{userId}/unarchive' },
  archiveUser: { method: 'post', path: '/{userId}/archive' },
  archiveGroup: { method: 'post', path: '/groups/{groupId}/archive' },
  addGroupMember: { method: 'post', path: '/groups/{groupId}/members' },
  removeGroupMember: { method: 'post', path: '/groups/{groupId}/members/remove' },
  getOrganisationNotificationPreferences: { method: 'get', path: '/organisation/preferences' },
  updateOrganisationNotificationPreferences: { method: 'post', path: '/organisation/preferences' },
  getOutOfOfficeDelegation: { method: 'get', path: '/out-of-office/{delegatorId}' },
  setOutOfOfficeDelegates: { method: 'post', path: '/out-of-office/{delegatorId}' },
  searchUsers: { method: 'get', path: '/search' },
  listUserDetailsPaginated: { method: 'post', path: '/list-paginated' },
  getOrgDomainSettings: { method: 'get', path: '/organisation/domain-settings' },
} as const
